import { n$2, t$2, u$1 } from '@/js/global/global';
import { getMediaQuery, atBreakpointChange} from '@/js/global/helpers'
import { srraf } from '@/js/modules/scroll-handlers'
import { register } from '@/js/global/shopify-theme-sections'
import { announce } from "../global/helpers";

const selectors$v = {
  slider: "[data-slider]",
  slide: "[data-slider] [data-slide]",
  navPrev: ".slider-nav-button-prev",
  navNext: ".slider-nav-button-next",
  mobileOnlyInner: ".announcement-bar__item-inner-mobile-only",
  desktopOnlyInner: ".announcement-bar__item-inner-desktop-only",
  playPause: ".announcement-bar__play-pause",
};
register("announcement-bar", {
  setHeightVariable() {
    if (this.container.offsetHeight !== this.lastSetHeight) {
      document.documentElement.style.setProperty("--announcement-height", "".concat(this.container.offsetHeight, "px"));
      this.lastSetHeight = this.container.offsetHeight;
    }
  },
  onLoad() {
    this.setHeightVariable();
    this.widthWatcher = srraf( () => {
      this.setHeightVariable();
    });
    this.disableTabbingToInners = function () {
      // Disable tabbing on items that aren't shown
      const desktopOnlyInners = t$2(selectors$v.desktopOnlyInner, this.container);
      const mobileOnlyInners = t$2(selectors$v.mobileOnlyInner, this.container);
      const desktopIsMobileSize = window.matchMedia(getMediaQuery("below-720")).matches;
      desktopOnlyInners.forEach(inner => {
        inner.toggleAttribute("inert", desktopIsMobileSize);
      });
      mobileOnlyInners.forEach(inner => {
        inner.toggleAttribute("inert", !desktopIsMobileSize);
      });
    };
    this.sliderContainer = n$2(selectors$v.slider, this.container);
    this.slides = t$2(selectors$v.slide, this.container);
    this.navPrev = t$2(selectors$v.navPrev, this.container);
    this.navNext = t$2(selectors$v.navNext, this.container);
    this.disableTabbingToInners();
    this.breakPointHandler = atBreakpointChange(720, () => {
      this.disableTabbingToInners();
    });
    if (this.slides.length < 2) {
      return null;
    }
    const autoplayEnabled = this.sliderContainer.dataset.autoplayEnabled == "true";
    const autoplayDelay = parseInt(this.sliderContainer.dataset.autoplayDelay, 10);
    let _this = this;
    import('@/js/vendor/swiper-chunk.js').then(_ref2 => {
      let {
        Swiper,
        Navigation,
        Autoplay
      } = _ref2;
      this.swiper = new Swiper(this.sliderContainer, {
        on: {
          init() {
            u$1(_this.container, "slider-active");
          },
          afterInit() {
            _this.bindPlayPause();
          },
          slideChangeTransitionEnd() {
            const slideEls = this.slides;
            setTimeout(function () {
              slideEls.forEach(slide => {
                slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
              });
            }, 50);
          },
          navigationNext: (swiper) => {
            announce(`Slide ${swiper.realIndex + 1}`);
          },
          navigationPrev: (swiper) => {
            announce(`Slide ${swiper.realIndex + 1}`);
          },
        },
        modules: [Navigation, Autoplay],
        grabCursor: true,
        loop: true,
        autoplay: autoplayEnabled ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: false,
        } : false,
        navigation: {
          nextEl: this.navNext,
          prevEl: this.navPrev
        }
      });
      // PauseOnMouseEnter causes autoplay stopping/starting to break, manually reimplement this functionality below.
      const button = this.container.querySelector(selectors$v.playPause);
      this.container.addEventListener('mouseenter', () => {
        this.swiper.autoplay.stop();
      })
      this.container.addEventListener('mouseleave', () => {
        if (button.dataset.state === 'pause') {
          this.swiper.autoplay.start();
        }
      })
    });
  },
  bindPlayPause() {
    const button = this.container.querySelector(selectors$v.playPause);
    button.addEventListener("click", () => {
      if (button.dataset.state === "pause") {
        button.setAttribute("data-state", "play");
        button.setAttribute("aria-label", button.dataset.play);
        this.swiper.autoplay.stop();
      } else {
        button.setAttribute("data-state", "pause");
        button.setAttribute("aria-label", button.dataset.pause);
        this.swiper.autoplay.start();
      }
    });
    if (this.swiper) {
      // PauseOnMouseEnter causes autoplay stopping/starting to break, manually reimplement this functionality below.
      this.container.addEventListener('mouseenter', () => {
        this.swiper.autoplay.stop();
      })
      this.container.addEventListener('mouseleave', () => {
        if (button.dataset.state === 'pause') {
          this.swiper.autoplay.start();
        }
      })
    }
    // Wait for next tick
    setTimeout(()=> {
      if (window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true) {
        button.setAttribute("data-state", "play");
        button.setAttribute("aria-label", button.dataset.play);
        this.slideshow.autoplay.stop();
      }
    })
  },
  onBlockSelect(_ref3) {
    var _this$swiper, _this$swiper$autoplay, _this$swiper2;
    let {
      target: slide
    } = _ref3;
    const index = parseInt(slide.dataset.index, 10);
    (_this$swiper = this.swiper) === null || _this$swiper === void 0 ? void 0 : (_this$swiper$autoplay = _this$swiper.autoplay) === null || _this$swiper$autoplay === void 0 ? void 0 : _this$swiper$autoplay.stop();
    (_this$swiper2 = this.swiper) === null || _this$swiper2 === void 0 ? void 0 : _this$swiper2.slideToLoop(index);
  },
  onBlockDeselect() {
    var _this$swiper3, _this$swiper3$autopla;
    (_this$swiper3 = this.swiper) === null || _this$swiper3 === void 0 ? void 0 : (_this$swiper3$autopla = _this$swiper3.autoplay) === null || _this$swiper3$autopla === void 0 ? void 0 : _this$swiper3$autopla.start();
  },
  onUnload() {
    var _this$swiper4, _this$widthWatcher;
    (_this$swiper4 = this.swiper) === null || _this$swiper4 === void 0 ? void 0 : _this$swiper4.destroy();
    (_this$widthWatcher = this.widthWatcher) === null || _this$widthWatcher === void 0 ? void 0 : _this$widthWatcher.destroy();
  }
});
